module.exports = __webpack_public_path__ + "media/landing_page/star-icon-9af7fa18.svg";